<template>
    <v-col cols="12" class="py-0">
        <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.name">
                <component :is="item.name" :disabled="item.disabled"></component>
                <dms-users-form-actions v-if="!preview"></dms-users-form-actions>
                <!-- <patient-form-actions v-if="item.hasActions"></patient-form-actions> -->
            </v-tab-item>
        </v-tabs-items>
    </v-col>
</template>

<script>
export default {
    props: {
        preview: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            items: [
                { name: 'dms-users-details', hasActions: false, disabled: this.preview },
                { name: 'dms-users-permissions', hasActions: false, disabled: this.preview },
            ],
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.dms_users.tab;
            },
            set(value) {
                this.$store.dispatch('dms_users/changeTab', value);
            },
        },
    },
};
</script>

<style></style>
